<template>
  <div class="secretClass">
    <h5>Secret View Window (Component will live inside this)</h5>
    <SecretDatabaseStats />
  </div>
</template>

<script>
import SecretDatabaseStats from "@/components/SecretDatabaseStats.vue";

export default {
  components: {
    SecretDatabaseStats
  }
};
</script>

<style lang="scss" scoped>
.secretClass {

  position: absolute;
  left: 0;
  right: 0;
  margin: 50px;

  top: 50px;
  height: 600px;
  border: solid 2px black;
  background-color: grey;
}
</style>
